<template>
  <div v-if="crossitem">
    <div id="addons-modal-wrapper" >
      <div class="modal fade addons-modal" ref="addonsModal" :id="'addons'+secondlist" tabindex="-1" role="dialog" :class="[{ 'show': addonModal == true}]">
        <div class="modal-dialog" v-if="modalItem && modalItem.data">
          <div class="modal-content" style="width:75%!important;left: 50%;transform: translate(-50%, 10px);">
            <div class="modal-header">
              <div class="modal-title h3">{{ modalItem.data | itemNameVariation  }}</div>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="closeModal()">&times;</button>
            </div>
            <div class="modal-body p-4">
              <div>
                <ul class="list-unstyled single-list">
                  <li>
                    <div class="d-flex border-bottom">
                      <span class="w-50 font-weight-bold">{{ $translate("Ceres::Template.singleItemNumber") }}</span>
                      <span>{{ modalItem.data.variation.number }}</span>
                    </div>
                  </li>
                  <template v-for="prop in modalItem.data.variationProperties">
                    <li v-if="prop.property.id!=9 && prop.property.id!=76 && prop.property.id != 39 && prop.property.id != 86 && prop.property.id != 84 && prop.property.id != 18 & prop.property.id != 106 & prop.property.id != 341 &&  prop.property.id!= 421 && prop.property.id!= 418 && prop.property.id!= 419 && prop.property.id!= 434 && (prop.values.value != '') && prop.property.display.includes('showOnItemsPage')">
                      <div class="d-flex border-bottom">
                        <span class="w-50 font-weight-bold">{{ prop.property.names.name }}</span>
                        <span v-if="prop.property.id !=423  && prop.property.id !=424 && prop.property.id !=425 && prop.property.id != 426 && prop.property.id != 188 && prop.property.id !== 405 && prop.property.id !== 463">
                          <template v-if="prop.property.cast == 'multiSelection' ">
                              <template v-if="prop.property.id == 433 || prop.property.id == 427 ||  prop.property.id == 428 ">
                                      <template v-for="multi in prop.values">
                                          <template v-if="(multi.value !== 'Ja' && multi.value !== 'ja' && multi.value !== 'Yes' && multi.value !== 'yes') || prop.values.length < 2 ">
                                              <template v-if="prop.property.id == 433">
                                                    {{ multi.value }} x
                                              </template>
                                              <template v-else>
                                                    {{ multi.value }}
                                              </template>
                                          </template>
                                      </template>
                              </template>
                              <template v-else v-for="multi in prop.values">
                                 - {{ multi.value }}  <br>
                              </template>
                          </template>
                          <template v-if="">
                             {{ prop.values.value }}
                          </template>
                        </span>
                        <span v-else-if="prop.property.id == 463">
                            <template v-if="prop.values.value >= 100">
                               {{ prop.values.value / 100 }} m
                            </template>
                            <template v-else>
                                {{ prop.values.value }} cm
                            </template>
                        </span>
                        <span v-else-if="prop.property.id !== 405" >
                          <template v-if="prop.values.value >= 100">
                             {{ prop.values.value / 100 }}  m
                          </template>
                          <template v-else>
                              {{ prop.values.value }}  cm
                          </template>
                        </span>
                        <span v-else-if="prop.property.id == 405" >
                        <template v-if="prop.values.value >= 1000">
                          {{ prop.values.value / 1000 }}  kg
                        </template>
                        <template v-else>
                           {{ prop.values.value }}  g
                        </template>
                         </span>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="text-center mt-4 mb-4">
                <img loading="lazy" class="img-fluid" :src="modalItem.data.images | itemImages('urlPreview') | itemImage" :alt="modalItem.data | itemNameVariation">
              </div>

              <div class="d-flex justify-content-between">
                <div>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" aria-hidden="true" @click="redirectToItem(modalItem)">
                    Zum Artikel
                  </button>
                </div>
                <div >
                  <button type="button" class="btn btn-primary" data-dismiss="modal" aria-hidden="true" @click="closeModal()">
                    Schließen
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="crosslist"  v-if="secondlist != 'true'">
      <div class="h3 mb-3">{{ $translate("Woerner::Template.addonItemsHeadline") }}</div>
      <ul class="list-unstyled single-crosslist">
        <li v-for="(item,index) in crossitem.slice(0,4)" class="mb-1 crosslistitem" :data-variation-id="item.data.variation.id">
          <input class="d-none" type="text" :value="item.data.variation.id">
          <input type="checkbox" class="mr-3 d-none" :id="'var_'+item.data.variation.id">
          <label :for="'var_'+item.data.variation.id" class="cursor d-flex align-items-center mb-0">
            <div class="d-flex">
              <div class="mr-3">
                <img loading="lazy" class="img-fluid" :src="item.data.images | itemImages('urlPreview') | itemImage" :alt="item.data.texts.name1">
              </div>
              <div class="flex-fill">
                <div class="crosslisttitle">
                  <b>{{ item.data | itemNameVariation  }}</b>
                </div>
                <div class="crosslistadditional">
                  <div class="d-flex">
                    <div>
                      +{{ item.data.prices.default.price.formatted }}
                      <span class="vat small text-muted">
                    ({{ $translate("Ceres::Template.singleItemInclVAT") }})
                    </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="d-flex flex-fill justify-content-end pr-1">
              <a data-toggle="modal" :href="'#addons'+secondlist" @click="setModal(item)">
                <i class="fa fa-info-circle" style="font-size: 20px;padding: 7px;" aria-hidden="true"  ></i>
              </a>
            </div>
          </label>
        </li>
      </ul>
      <div  class="mb-3 mt-1 h5" v-if="crossitem.length > 4" style="text-align: center;">
        <a style="color: #28a745!important;"
           href="#extraCrossList">
          <span style="text-decoration: underline;"> {{ $translate("Woerner::Template.singleCrossExtraLink") }}</span>
        </a>
      </div>
    </div>
    <template  v-else-if="crossitem.length > 4">
      <div class="widget-accordion widget-primary" id="accordion_5">
        <div class="card" id="extraCrossList">
          <button class="card-header btn btn-link text-appearance"
                  id="heading_5_5" type="button" data-toggle="collapse"
                  data-target="#collapse_5_5" aria-expanded="true"
                  aria-controls="collapse_5_5" aria-label="Toggle replacement parts">
            <div class="h5 pr-5 mb-0">
              {{ $translate("Woerner::Template.singleCrossTitle") }}
              <i class="fa fa-angle-down centered-angle"></i>
            </div>
          </button>

          <div id="collapse_5_5" class="collapse show"
               aria-labelledby="heading_5_5"
               data-parent="#accordion_5">
            <div class="card-body px-0">
              <div class="crosslist" >

                <div class="row list-unstyled single-crosslist">
                  <div v-for="item in crossitem.slice(4)" class="mb-1 col-lg-6 col-12 crosslistitem" :data-variation-id="item.data.variation.id">
                    <input class="d-none" type="text" :value="item.data.variation.id">
                    <input type="checkbox" class="mr-3 d-none" :id="'var_'+item.data.variation.id">
                    <label :for="'var_'+item.data.variation.id" class="cursor d-flex align-items-center mb-0">
                      <div class="d-flex">
                        <div class="mr-3">
                          <img class="img-fluid" loading="lazy"src="item.data.images | itemImages('urlPreview') | itemImage" :alt="item.data.texts.name1">
                        </div>
                        <div class="flex-fill">
                          <div class="crosslisttitle">
                            <b>{{ item.data | itemNameVariation  }}</b>
                          </div>
                          <div class="crosslistadditional">
                            <div class="d-flex">
                              <div>
                                +{{ item.data.prices.default.price.formatted }}
                                <span class="vat small text-muted">
                    ({{ $translate("Ceres::Template.singleItemInclVAT") }})
                    </span>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="d-flex flex-fill justify-content-end pr-1">
                        <a data-toggle="modal" :href="'#addons'+secondlist" @click="setModal(item)">
                          <i class="fa fa-info-circle" style="font-size: 20px;padding: 7px;" aria-hidden="true"  ></i>
                        </a>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </template>

  </div>

</template>

<script>
import {hasVat} from "../helper/OrderPropertyHelper";
import ModalService from "../services/ModalService";

export default
{
  props:
      {
        secondlist:
            {
              type:String,
              default:''
            },
        crossitemsprop:
            {
              type:Array,
              default:() => []
            }
      },
  created() {
    /*console.log('cross',this.crossitem)*/
  },
  data(){
    return {
      crossitem:this.crossitemsprop,
      modalItem:{},
      addonModal: false
    }
  },
  inject: {
    itemId: {
      default: null
    }
  },
  computed:
      {
        currentVariation() {
          return this.$store.getters[`${this.itemId}/currentItemVariation`];
        }
      },
  watch: {
    currentVariation(currentVar) {
        this.getVariationCrosseller(currentVar)
    }
  },
  methods:
  {
    getVariationCrosseller(currentVariation)
    {
      let varProps = currentVariation.variationProperties
      let _self = this;

      let data  = {
        'varProps':varProps
      }

      $.ajax({
        type: 'POST',
        url: '/item/getAddonCrossSeller/',
        data: data,
        success: function (response) {
          _self.crossitem =  response
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // console.log(jqXHR);
        }
      })
    },
    redirectToItem(item)
    {
      let link = '';
      if(item.data.texts.lang != 'de')
      {
        link = '/'+item.data.texts.lang + '/'  + item.data.texts.urlPath + '_' + item.data.item.id + '/';

      }
      else{
        link = '/'+ item.data.texts.urlPath + '_' + item.data.item.id +'/';
      }
      window.location.href = link;

    },
    setModal(item)
    {
      this.modalItem = item;

      this.addonModal = true;
    },
    closeModal()
    {
      this.addonModal = false;
    },
  }
}
</script>
